import React from "react";

const filterContainerStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  alignItems: "center",
  marginBottom: "20px",
};

const filterButtonStyle = (isActive, variant, isDarkMode) => {
  const colors = {
    primary: "#009689",
    info: "#17a2b8",
    warning: "#ffc107",
    success: "#009689",
    secondary: "#6c757d",
    danger: "#dc3545",
    purple: "#6f42c1",
  };
  const color = colors[variant] || colors.primary;

  return {
    padding: "8px 16px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: 500,
    border: isActive ? "none" : `1px solid ${isDarkMode ? "#3d3d5c" : "#e9ecef"}`,
    background: isActive ? color : isDarkMode ? "#252542" : "#ffffff",
    color: isActive ? "#FFFFFF" : isDarkMode ? "#e4e4e4" : "#333333",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  };
};

const filterCountStyle = (isActive, isDarkMode) => ({
  backgroundColor: isActive
    ? "rgba(255,255,255,0.25)"
    : isDarkMode
      ? "#3d3d5c"
      : "#e9ecef",
  color: isActive ? "#FFFFFF" : isDarkMode ? "#e4e4e4" : "#333333",
  padding: "2px 8px",
  borderRadius: "10px",
  fontSize: "11px",
  fontWeight: 600,
});

const dividerStyle = (isDarkMode) => ({
  width: "1px",
  height: "32px",
  backgroundColor: isDarkMode ? "#3d3d5c" : "#e9ecef",
  margin: "0 8px",
});

const MultiSelectFilterBar = ({
  filterGroups,
  selectedFilters,
  onFilterChange,
  isDarkMode,
  showDividers = true,
}) => {
  const handleClick = (groupKey, value, options) => {
    const currentSet = selectedFilters[groupKey] || new Set();
    const allValues = options.map((o) => o.value);

    if (value === "__all__") {
      const allSelected =
        allValues.length === currentSet.size &&
        allValues.every((v) => currentSet.has(v));
      onFilterChange(groupKey, allSelected ? new Set() : new Set(allValues));
      return;
    }

    const newSet = new Set(currentSet);
    if (newSet.has(value)) {
      newSet.delete(value);
    } else {
      newSet.add(value);
    }
    onFilterChange(groupKey, newSet);
  };

  return (
    <div style={filterContainerStyle}>
      {filterGroups.map((group, groupIdx) => {
        const currentSet = selectedFilters[group.key] || new Set();
        const allValues = group.options.map((o) => o.value);
        const isAllActive =
          currentSet.size === 0 ||
          (allValues.length === currentSet.size &&
            allValues.every((v) => currentSet.has(v)));

        return (
          <React.Fragment key={group.key}>
            {groupIdx > 0 && showDividers && (
              <div style={dividerStyle(isDarkMode)} />
            )}

            <button
              style={filterButtonStyle(isAllActive, "primary", isDarkMode)}
              onClick={() =>
                handleClick(group.key, "__all__", group.options)
              }
            >
              All {group.label}
            </button>

            {group.options.map((option) => {
              const isActive = currentSet.has(option.value);
              return (
                <button
                  key={option.value}
                  style={filterButtonStyle(
                    isActive,
                    option.variant,
                    isDarkMode
                  )}
                  onClick={() =>
                    handleClick(group.key, option.value, group.options)
                  }
                >
                  {option.label}
                  {option.count !== undefined && (
                    <span style={filterCountStyle(isActive, isDarkMode)}>
                      {option.count}
                    </span>
                  )}
                </button>
              );
            })}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default MultiSelectFilterBar;
